const taxInvoicesTypes = {
  NOTA_FISCAL_ELETRONICA: 'NFe',
  CUPOM_FISCAL_ELETRONICO: 'CFe'
};

export default taxInvoicesTypes;
